<template>
  <div class="search-box container">
    <el-image
      class="logo"
      :src="require('@/assets/logo.png')"
      mode="scaleToFill"
      @click="$router.push({name: 'home'})"
    />
    <div class="search">
      <div class="search-text-box">
        <el-input class="search-text" v-model="keyword" clearable />
      </div>
      <div class="search-btn" @click="onSearch">搜索</div>
    </div>
    <div class="push-btn" @click="$router.push({name: 'assets-push'})">
      免费发布资源
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      keyword: null
    }
  },
  methods: {
    onSearch() {
      if (!this.keyword) {
        this.$message.warning('请输入搜索关键词')
        return false
      } else {
        this.$router.push({name: 'list', query: {keyword: this.keyword}})
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  .logo {
    margin: 0 20px;
    height: 40px;
    cursor: pointer;
  }
  .search {
    display: flex;
    flex-direction: row;
    .search-text-box {
      .search-text {
        width: 570px;
        height: 38px;
        display: inline-block;
        border: 2px solid #0fb264;
        border-right: none;
        vertical-align: top;
        // border-radius: 8px 0 0 8px;
        overflow: hidden;
        ::v-deep .el-input__inner {
          height: 38px;
          border: 0 !important;
        }
      }
    }
    .search-btn {
      cursor: pointer;
      width: 91px;
      height: 40px;
      color: #fff;
      font-size: 16px;
      padding: 0;
      padding-top: 4px\9;
      background: #0fb264;
      border: 1px solid #0fb264;
      // border-radius: 0 8px 8px 0;
      vertical-align: top;
      cursor: pointer;
      -webkit-appearance: none;
      outline: none;
      letter-spacing: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .push-btn {
    margin-left: 50px;
    padding: 0 30px;
    height: 42px;
    color: #fff;
    font-size: 16px;
    background: $red;
    cursor: pointer;
    -webkit-appearance: none;
    outline: none;
    letter-spacing: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

</style>